import type { StrideThreat } from '@/types/stride';

const BACKEND_BASE = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

async function request<T>(url: string, opts?: RequestInit): Promise<T> {
  const res = await fetch(url, { credentials: 'include', ...opts });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  if (res.status === 204) return undefined as unknown as T;
  return res.json();
}

export const strideThreatService = {
  list(projectId: number): Promise<StrideThreat[]> {
    return request<StrideThreat[]>(`${BACKEND_BASE}/api/stride-threats/${projectId}`);
  },

  remove(id: number): Promise<void> {
    return request<void>(`${BACKEND_BASE}/api/stride-threats/${id}`, { method: 'DELETE' });
  },

  clearAll(projectId: number): Promise<void> {
    return request<void>(`${BACKEND_BASE}/api/stride-threats/project/${projectId}`, { method: 'DELETE' });
  },
};
